import { Box, Typography, Link, IconButton, useTheme } from '@mui/material';

import { Icon } from '@widget/toolbox/components';
import { pushGAEvent } from '@widget/analytics';
import { attachCurrentQueryParams } from '@widget/utils/attachCurrentQueryParams';

import type React from 'react';
import type { NavigatinItemProps } from './types';

export const MobileNavigationItem: React.FC<NavigatinItemProps> = ({
  navItem,
  current,
  setCurrent,
}) => {
  const theme = useTheme();
  const active = navItem.name === current;
  const hasChildren = !!navItem.children?.length;

  const border = '1px solid rgba(255, 255, 255, .2)';

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pl={2}
        borderBottom={border}
      >
        <Link
          href={attachCurrentQueryParams(navItem.link.url)}
          color={theme.palette.primary.contrastText}
          underline="none"
          onClick={() => {
            pushGAEvent('navigation_click', {
              label: navItem.name,
              info: 'header',
            });
          }}
          style={{ width: '100%' }}
        >
          <Typography color={theme.palette.primary.contrastText} component="span" fontWeight="bold">
            {navItem.name}
          </Typography>
        </Link>

        {hasChildren && (
          <Box sx={{ borderLeft: border }}>
            <IconButton
              aria-label={`${navItem.name} submenu`}
              onClick={() => setCurrent?.(navItem.name)}
            >
              {active ? (
                <Icon
                  size={'inherit'}
                  type="ArrowUpMenu"
                  color={theme.palette.primary.contrastText}
                />
              ) : (
                <Icon
                  size={'inherit'}
                  type="ArrowDownMenu"
                  color={theme.palette.primary.contrastText}
                />
              )}
            </IconButton>
          </Box>
        )}
      </Box>
      {active &&
        navItem.children?.map((subItem) => (
          <Box
            key={subItem.name}
            display="flex"
            px={2}
            width="100%"
            borderBottom={border}
            py={1}
            bgcolor="#195d65"
          >
            <Link
              href={attachCurrentQueryParams(subItem.link.url)}
              underline="none"
              onClick={() => {
                pushGAEvent('subnavigation_click', {
                  label: subItem.name,
                  info: navItem.name,
                });
              }}
              style={{ width: '100%' }}
            >
              <Typography
                color={theme.palette.primary.contrastText}
                component="span"
                fontWeight="bold"
                noWrap={true}
              >
                {subItem.name}
              </Typography>
            </Link>
          </Box>
        ))}
    </>
  );
};
